import { render } from "./CustomTableComponent.vue?vue&type=template&id=bea7402e&ts=true"
import script from "./CustomTableComponent.vue?vue&type=script&lang=ts"
export * from "./CustomTableComponent.vue?vue&type=script&lang=ts"

import "./CustomTableComponent.vue?vue&type=style&index=0&id=bea7402e&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__